import React, { useState, useEffect, useRef } from 'react';
import { Input } from 'antd';

type Props = {
  readOnly: String,
  valueInCents: Number,
  onChange: Function,
  currencyPrefix: String,
}

const EditableCostInput = (props: Props) => {
  const {
    readOnly = 'false',
    valueInCents,
    onChange,
    currencyPrefix,
  } = props;

  const [inputValue, setInputValue] = useState('');
  const inputRef = useRef(null);

  // Sync display value when external value changes (like on row switch)
  useEffect(() => {
    if (!Number.isNaN(Number(valueInCents))) {
      setInputValue((parseFloat(valueInCents) / 100).toFixed(2));
    } else {
      setInputValue('');
    }
  }, [valueInCents]);

  const commitChange = () => {
    const parsed = parseFloat(inputValue);
    if (!Number.isNaN(Number(parsed))) {
      onChange(parseInt((parsed * 100), 10));
    } else {
      onChange(0); // or 0 if you prefer
      setInputValue(Number(0).toFixed(2));
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      commitChange();
      if (inputRef.current) {
        inputRef.current.blur(); // remove focus after Enter
      }
    }
  };

  const handleDirectValueSet = (e) => {
    if (Number.isNaN(Number(e.target.value))) {
      return;
    }
    setInputValue(e.target.value);
  };

  return (
    <Input
      readOnly={readOnly === 'true'}
      prefix={currencyPrefix}
      ref={inputRef}
      value={inputValue}
      onChange={handleDirectValueSet}
      onBlur={commitChange}
      onKeyDown={handleKeyDown}
      placeholder="0.00"
      disabled={readOnly === 'true'}
    />
  );
};

export default EditableCostInput;
